import Loader from "components/shared/loader";
import { scenarioQuestionTypesEnum } from "helpers/enums";
import { scenarioAnswerOption } from "helpers/models";
import React, { Fragment } from "react";
import Form from "./form";
import Show from "./show";

const ScenarioAnswerOptions = (props) => {
    const onChange = ({ name, value }, i) => {
        const { scenarioQuestion } = props;
        const answerOptions = scenarioQuestion.answerOptions.map((item, index) =>
            index === i ? { ...item, [name]: value } : item,
        );
        props.onChange({ name: "answerOptions", value: answerOptions });
    };

    const addAnswerOption = () => {
        const {
            scenarioQuestion: { id, answerOptions },
            scenario,
        } = props;
        answerOptions.push({
            ...scenarioAnswerOption,
            scenarioId: scenario.id,
            questionId: id,
            order: answerOptions.length,
        });
        props.onChange({ name: "answerOptions", value: answerOptions });
    };

    return (
        <div className="table-responsive-sm">
            <table className="table table-sm table-borderless mb-1">
                <thead>
                    <tr>
                        <th>Текст ответа</th>
                        <th>PropertyName</th>
                        {scenarioQuestionTypesEnum.SelectMultiple !== props.scenarioQuestion.questionType && (
                            <th>Следующий вопрос</th>
                        )}
                        {props.editMode && <th className="scenarios__answer-action" />}
                    </tr>
                </thead>
                <tbody>
                    {props.scenarioQuestion.answerOptions.map((item, i) => (
                        <Fragment key={i}>
                            {item.isLoading && (
                                <tr>
                                    <td colSpan="4">
                                        <div className="loader-snippet--disable-loader">
                                            <Loader />
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {props.editMode ? (
                                <Form
                                    questionOptions={props.questionOptions}
                                    answerOption={item}
                                    scenarioQuestion={props.scenarioQuestion}
                                    onChange={(data) => onChange(data, i)}
                                    removeAnswerOption={props.removeAnswerOption.bind(this, i)}
                                />
                            ) : (
                                <Show
                                    {...item}
                                    questionOptions={props.questionOptions}
                                    scenarioQuestion={props.scenarioQuestion}
                                />
                            )}
                        </Fragment>
                    ))}
                </tbody>
            </table>
            {props.editMode && (
                <div className="d-flex justify-content-start pb-4">
                    <div className="link" onClick={addAnswerOption}>
                        <small>Добавить вариант ответа</small>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScenarioAnswerOptions;
